import React from "react";

const SupplyAndInstall = () => {
  return (
    <>
      <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>Our Services</h2>
            <p>
            Choosing our flooring service ensures a seamless and hassle-free experience from start to finish. Our team of highly skilled professionals is dedicated to delivering exceptional craftsmanship and attention to detail, ensuring that your flooring installation or renovation project exceeds your expectations. With our expertise and commitment to customer satisfaction, you can trust us to bring your vision to life.
            </p>
            <br />
            <p>
            We offer a wide selection of flooring options to suit your needs and preferences. From elegant hardwood and versatile laminate to luxurious carpet and durable vinyl, we have a diverse range of materials and styles to choose from. Our knowledgeable staff is always available to guide you through the selection process, helping you find the perfect flooring solution that matches your budget and design goals.
            </p>
            <br />
            <p>
            Quality is at the forefront of our service. We source our materials from reputable suppliers, ensuring that you receive flooring products of the highest standards. Our installation techniques are meticulous, guaranteeing a precise and long-lasting result. When you choose our flooring service, you can rest assured that you are investing in a durable and aesthetically pleasing flooring solution that will stand the test of time.
            </p>
            <br />
          </article>
          <article className="card">
            <div className="director-photo">
            <img
                src={
                  "../Images/articles/installation_main.jpg"
                }
                alt="Installation"
                className="article-img"
              />
            </div>
          </article>
        </div>
      </div>
    </section>
    </>
  );
};

export default SupplyAndInstall;